import * as z from 'zod';

import { statusFormSchema } from '@/_schemas/status-input';

import { industryQueryBaseSchema } from './industry-query-base-schema';
import { industryQuerySchema } from './industry-query-schema';

export const industryFormSchema = industryQuerySchema
  .omit({
    name: true,
    status: true,
    description: true,
    consumer_label: true,
    parent_id: true,
    parent: true,
    clients_count: true,
  })
  .extend({
    name: z.string().min(3),
    status: statusFormSchema,
    description: z.string(),
    consumer_label: z.string(),
    parent: industryQueryBaseSchema.nullable(),
  });

export type IndustryFormSchema = z.infer<typeof industryFormSchema>;
